import { useLocale } from '@/contexts/LocaleContext';
import { NavLink, Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useHubTabs } from '@/lib/permisos';
import { Mail, Home, Send, FileText, Globe, BarChart3, List, Zap } from 'lucide-react';

/**
 * S176 — Solo mailing. Automáticos (cumpleaños/citas) → Marketing.
 */
const TABS = [
  { to: '/tenant/email', end: true, labelKey: 'email.home', icon: Home, module: 'marketing' },
  { to: '/tenant/email/nuevo', labelKey: 'email.new', icon: Send, module: 'marketing' },
  { to: '/tenant/email/envios', labelKey: 'email.history', icon: List, module: 'marketing' },
  { to: '/tenant/email/plantillas', labelKey: 'email.templates', icon: FileText, module: 'marketing' },
  { to: '/tenant/email/dominio', labelKey: 'email.domain', icon: Globe, module: 'marketing' },
  { to: '/tenant/email/informes', labelKey: 'email.reports', icon: BarChart3, module: 'marketing' },
];

export default function EmailHubLayout() {
  const { t } = useLocale();
  const location = useLocation();
  const navigate = useNavigate();
  const { tabs: visibleTabs } = useHubTabs(TABS);

  return (
    <div className="space-y-4" data-testid="email-hub">
      <div className="flex items-start justify-between flex-wrap gap-3">
        <div>
          <h1 className="text-lg font-bold text-[#0F172A] flex items-center gap-2">
            <Mail className="w-5 h-5 text-[#F72585]" /> Email
          </h1>
          <p className="text-sm text-[#64748B]">
            Envíos masivos de correo con tu marca. Para cumpleaños o citas usa{' '}
            <button type="button" className="text-[#F72585] font-medium underline-offset-2 hover:underline"
              onClick={() => navigate('/tenant/marketing/automations')}>
              Marketing → Secuencias
            </button>
            .
          </p>
        </div>
        <button
          type="button"
          onClick={() => navigate('/tenant/email/nuevo')}
          className="inline-flex items-center gap-1.5 px-3 py-2 rounded-lg bg-[#F72585] text-white text-xs font-semibold hover:bg-[#d91d70]"
        >
          <Send className="w-3.5 h-3.5" /> Nuevo envío
        </button>
      </div>

      <div className="flex gap-1 border-b border-[#E2E8F0] overflow-x-auto" data-testid="email-hub-tabs">
        {visibleTabs.map(tab => (
          <NavLink
            key={tab.to}
            to={tab.to}
            end={tab.end}
            data-testid={`email-tab-${tab.to.split('/').pop() || 'home'}`}
            className={({ isActive }) => {
              const active = isActive
                || (tab.to === '/tenant/email/nuevo' && location.pathname.includes('/email/nuevo'));
              return `flex items-center gap-1.5 px-3 py-2.5 text-xs font-medium border-b-2 whitespace-nowrap ${
                active ? 'border-[#F72585] text-[#0F172A]' : 'border-transparent text-[#64748B] hover:text-[#0F172A]'
              }`;
            }}
          >
            <tab.icon className="w-3.5 h-3.5" />
            {tab.labelKey ? t(tab.labelKey) : tab.label}
          </NavLink>
        ))}
      </div>

      {/* soft redirect note if old deep link */}
      {location.pathname.includes('/email/automaticos') && (
        <div className="text-xs bg-amber-50 border border-amber-100 text-amber-900 rounded-lg px-3 py-2 flex items-center gap-2">
          <Zap className="w-3.5 h-3.5" />
          Los automáticos se movieron a Marketing.
          <button type="button" className="font-semibold underline" onClick={() => navigate('/tenant/marketing/automations')}>
            Ir ahora
          </button>
        </div>
      )}

      <Outlet />
    </div>
  );
}
